import { MedicalIndicatorType } from './medical.indicator.type'
import Comorbidity from '../models/medical.indicator/comorbidities'
import Medicament from '../models/medical.indicator/medicament'

export class FactoryMedicalIndicator {

    public static build(values: any, type: MedicalIndicatorType): any {
        switch (type) {
            case MedicalIndicatorType.COMORBIDITIES:
                return new Comorbidity().fromJSON(values)

            case MedicalIndicatorType.MEDICAMENTS:
                return new Medicament().fromJSON(values)

            default:
                return values
        }
    }
}
